import {
  FlexColumn,
  ModelForm,
} from '@equifinance/shared';
import styled from 'styled-components';
import {
  CreditItem, CreditTypes,
  useCreditContext,
} from '../../../../contexts/credit';
import UnsecuredCreditPackagingDetails from './UnsecuredCreditPackagingDetails';
import ConsolidationDetails from '../../Consolidation/ConsolidationDetails/ConsolidationDetails';
import { withExpandableRowErrors } from '../../../Errors/ExpandableRowErrors';

const Container = styled(FlexColumn)` ${({ theme }) => ` 
  gap:${theme.padding[4]};
  padding:${theme.padding[4]};
  background: ${theme.colours.neutral[9]};
`}`;

export function UnsecuredCreditDetails({
  data: creditItem,
}: {
  data: CreditItem,
}) {
  const { credit, updateCreditItem } = useCreditContext();
  const { errors, warnings } = credit;

  const update = (values: any, disableIncrementUpdateCount: boolean = false) => updateCreditItem(
    values,
    creditItem.id,
    CreditTypes.UNSECURED,
    disableIncrementUpdateCount,
  );

  return (
    <>
      {creditItem && (
        <ModelForm model={creditItem} update={update} errors={errors} warnings={warnings}>
          <Container>
            {!creditItem.ignored && (
              <ConsolidationDetails data={creditItem} type="unsecured" />
            )}
            <UnsecuredCreditPackagingDetails creditItem={creditItem} />
          </Container>
        </ModelForm>
      )}
    </>
  );
}

export default withExpandableRowErrors(UnsecuredCreditDetails);
